import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

type Props = {
  items: {
    '@id': string;
    id: string;
    title: string;
    active?: string;
  }[];
  isEditMode?: boolean;
};

export default function ViewItem({ items, isEditMode = false }: Props) {
  return (
    <nav className="product-menu">
      <ul>
        {items.map((item) => (
          <li className={item?.active} key={item.id} contentEditable={false}>
            {/* @ts-ignore */}
            <ConditionalLink
              condition={!isEditMode}
              item={item}
              openLinkInNewTab={false}
            >
              {item.title}
            </ConditionalLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
